import React, { useState } from 'react'

export const ConfirmModal = (props) => {
  const { title, desc, hideModal, handleAgree } = props

  const [submitting, setSubmitting] = useState(false)

  return (
    <>
      <div className="card-header">
        <div className="card-title">{title}</div>
      </div>
      <div className="card-body">
        {desc}
        <div className="text-right m-t-5">
          <button
            className="btn btn-link text-dark m-r-2"
            onClick={() => {
              hideModal()
            }}
          >
            No
          </button>
          <button
            className="btn btn-dark"
            disabled={submitting}
            onClick={async () => {
              setSubmitting(true)
              await handleAgree()
              setSubmitting(false)
              hideModal()
            }}
          >
            Yes
          </button>
        </div>
      </div>
    </>
  )
}
